import axios from "axios";
import { Placeholder } from "react-bootstrap";
import Dashboard from "pages/retaguarda/dashboard";
import Empresas from "pages/retaguarda/empresas";
import { useFaturamentoDiario } from "hooks/useDashboardStats";

// Tela inicial: dashboard para quem tem a permissão ViewKPIsGerais, lista de empresas para os demais.
// O front não recebe os códigos de permissão, então o 403 do primeiro KPI decide — é a mesma query
// do card de faturamento diário, então o dashboard reaproveita o cache sem request extra.
const Home = () => {
  const { isLoading, error } = useFaturamentoDiario();

  if (isLoading) {
    return (
      <Placeholder as="div" animation="wave" className="py-5">
        <Placeholder xs={12} style={{ height: "120px" }} className="mb-4 rounded" />
        <Placeholder xs={12} style={{ height: "320px" }} className="rounded" />
      </Placeholder>
    );
  }

  if (axios.isAxiosError(error) && error.response?.status === 403) {
    return <Empresas />;
  }

  return <Dashboard />;
};

export default Home;
